import * as Sentry from "@sentry/react";
import { type FC, useCallback, useEffect, useState } from "react";
import { useNavigate, useRouteError } from "react-router";
import { renderErrorFallback } from "../helpers/errorFallback.js";

/** React Router thinks they're special and need their own special error boundary. */
export const RouteErrorBoundary: FC = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const [eventId, setEventId] = useState<string | undefined>(undefined);
  useEffect(() => {
    setEventId(Sentry.captureException(error));
  }, [error]);

  const resetError = useCallback(() => {
    navigate(".", { replace: true });
  }, [navigate]);

  return renderErrorFallback({ eventId, resetError });
};
